import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";

import { TemplatesDetailColumns } from "./templatesDetailSetup";
import { getPacksByCommodityCodeFull } from "../../lib/api/pack";
import Grid from "../../lib/components/grid";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      width: "100%",
    },
  });

type TemplatesDetailProps = {
  maintenancemode: boolean;
  data: any;
  targets: any;
  counts: any;
  classesArr: any;
  coldrooms: any;
  brands: any;
  inventories: any;
  mgps: any;
  handleRemove: any;
  handleAdd: any;
  handleSave: any;
  handleTemplateDetailSelectedAdd: any;
  varietyId: any;
  commodityCode: any;
} & WithStyles<typeof styles>;

class TemplatesDetailUnstyled extends React.Component<TemplatesDetailProps, any> {
  state = {
    classes: undefined,
    maintenancemode: false,
    rows: undefined,
    targets: undefined,
    targetsRegion: [],
    targetsCountry: [],
    targetsMarket: [],
    counts: [],
    classesArr: [],
    coldrooms: [],
    brands: [],
    inventories: [],
    mgps: [],
    handleRemove: undefined,
    handleAdd: undefined,
    handleSave: undefined,
    handleTemplateDetailSelectedAdd: undefined,
    gridRef: undefined,
    selectedIndexes: [],
    selectedRows: new Set<React.Key>(),
    packs: [],
    currentColumnSelected: 0,
    currentRowSelected: 0,
    loading: false,
  };

  constructor(props) {
    super(props);
    this.state.classes = props.classes;
    this.state.maintenancemode = props.maintenancemode;
    this.state.handleRemove = props.handleRemove;
    this.state.handleAdd = props.handleAdd;
    this.state.handleSave = props.handleSave;
    this.state.handleTemplateDetailSelectedAdd = props.handleTemplateDetailSelectedAdd;
    this.state.gridRef = React.createRef();

    this.state.rows = props.data;
    this.state.counts = props.counts;
    this.state.brands = props.brands;
    this.state.coldrooms = props.coldrooms;
    this.state.classesArr = props.classesArr;
    this.state.inventories = props.inventories;
    this.state.mgps = props.mgps;

    this.state.targets = props.targets;

    props.targets.map((target) => {
      const targetrexist = this.state.targetsRegion.filter((region) => region.value == target.region);
      if (targetrexist.length == 0) {
        this.state.targetsRegion.push({ id: this.state.targetsRegion.length, value: target.region });
      }
    });
    this.state.targetsRegion = this.state.targetsRegion.sort((a, b) => (a.value < b.value ? -1 : 1));
  }

  loadData = async () => {
    if (!this.props.commodityCode) {
      console.warn("No commodity code provided");
      this.setState({ packs: [] });
      return;
    }

    //get packs by commodity code
    const commodityCode = this.props.commodityCode.trim();
    const packs = await getPacksByCommodityCodeFull(commodityCode);

    const processedPacks = packs
      .filter((p) => {
        try {
          const isActive = p.active === true || p.active === 1;
          const isValid = p && p.code && p["No Cartons"] != null;
          return isActive && isValid;
        } catch (err) {
          console.error("Error processing pack:", p, err);
          return false;
        }
      })
      .map((p) => {
        const processed = {
          id: p.id,
          code: p.code,
          carton: String(p["No Cartons"]),
          active: p.active,
        };
        return processed;
      })
      .sort((a, b) => {
        const codeCompare = a.code.localeCompare(b.code);
        if (codeCompare !== 0) return codeCompare;
        return Number(a.carton) - Number(b.carton);
      });

    this.setState({ packs: processedPacks });
  };

  componentDidMount(): void {
    this.loadData();
  }

  componentWillReceiveProps = async (props) => {
    this.setState({ rows: props.data });

    if (props.commodityCode !== this.props.commodityCode) {
      await this.loadData();
    }
  };

  handleChange = (property: string, updatedRows: any[]) => {
    const currentRows = this.state.rows || [];

    const updatedData = updatedRows.map((updatedRow, index) => {
      const currentRow = currentRows[index];

      if (currentRow && JSON.stringify(currentRow) !== JSON.stringify(updatedRow)) {
        let updated = { ...updatedRow };
        updated.isDirty = 1;

        if (updated.region !== currentRow.region) {
          updated = { ...updated, market: "", country: "" };
        }

        if (updated.count && updated.count.indexOf("/") == 0) {
          updated.count = updated.count.substring(1);
        }

        if (updated.country && updated.country != "CLEAR" && updated.country !== currentRow.country) {
          const targetIdentified = this.state.targets.find((target) => target.country == updated.country);
          if (targetIdentified) {
            updated = { ...updated, market: targetIdentified.market, region: targetIdentified.region };
          }
        }

        if (updated.country === "CLEAR") {
          updated = { ...updated, market: "", country: "", region: "" };
        }

        if (updated.country && updated.country !== currentRow.country) {
          const target = this.state.targets.find((tar) => tar.country == updated.country);
          if (target) {
            updated.target_id = target.id;
          }
        }

        if (updated.pack_code && updated.pack_code !== currentRow.pack_code) {
          const selectedPack = this.state.packs.find((pack) => pack.code === updated.pack_code);
          if (selectedPack) {
            updated = {
              ...updated,
              pack_id: selectedPack.id,
              pack_code: selectedPack.code,
            };
          }
        }

        if (updated.pack_carton && updated.pack_carton !== currentRow.pack_carton) {
          const pack = this.state.packs.find((pack) => pack.code === updated.pack_code && pack.carton === updated.pack_carton);
          if (pack) {
            updated = { ...updated, pack_id: pack.id };
          }
        }

        if (updated.code !== undefined && updated.code !== currentRow.code) {
          const inventory = this.state.inventories.find((inv) => inv.code === updated.code);
          if (inventory) {
            updated = {
              ...updated,
              code: inventory.code,
              inventory_id: inventory.id,
            };
          }
        }

        return updated;
      }

      return currentRow;
    });
    this.setState({ rows: updatedData });
  };

  handleSelectedRowChange = (selectedRow: any, columnInfo: any) => {
    const rowId = selectedRow.id || selectedRow.rowIdx;
    const keys: Set<React.Key> = new Set(this.state.selectedRows);

    if (keys.has(rowId)) {
      keys.delete(rowId);
    } else {
      keys.add(rowId);
    }

    const indexes = Array.from(keys);
    this.setState({
      selectedRows: keys,
      selectedIndexes: indexes,
      currentColumnSelected: columnInfo.selectedColumn,
      currentRowSelected: selectedRow.rowIdx
    });
  };

  handleAddNewTemplateLine = async () => {
    await this.handleSaveDirtyDetails();
    this.state.handleAdd();
  };

  handleSaveDirtyDetails = async () => {
    this.state.handleSave(this.state.rows.filter((row) => row.isDirty == 1));
  };

  handleSelectTemplateDetailLines = () => {
    this.state.handleTemplateDetailSelectedAdd(this.state.selectedIndexes.reduce((arr, idx) => {
      const row = this.state.rows.find(r => r.id === idx || r.rowIdx === idx);
      return row ? [...arr, row] : arr;
    }, []));
  };

  getGridColumns = (data, filters, columnArrangement, columnsWidth) => {
    const originalColumns = TemplatesDetailColumns(
      this.state.maintenancemode,
      this.state.targetsRegion,
      this.state.targets,
      this.state.counts,
      this.state.classesArr,
      this.state.coldrooms,
      this.state.brands,
      this.state.inventories,
      this.state.mgps,
      this.state.handleRemove,
      this.state.packs || [],
      data,
      filters,
      columnArrangement,
      columnsWidth
    );

    if (columnArrangement && columnArrangement.length > 0) {
      const arrangedColumns = [];

      for (const colName of columnArrangement) {
        const foundColumn = originalColumns.find(col =>
          col.name === colName || col.key === colName
        );
        if (foundColumn) {
          arrangedColumns.push(foundColumn);
        }
      }

      for (const column of originalColumns) {
        if (!arrangedColumns.find(col => col.key === column.key)) {
          arrangedColumns.push(column);
        }
      }

      return arrangedColumns;
    }
    return originalColumns;
  };

  render() {
    const { classes } = this.state;

    return (
      <div className={classes.root}>
        <Grid
          fill
          data={this.state.rows || []}
          loading={this.state.loading}
          GridColumns={this.getGridColumns}
          handleChange={this.handleChange}
          selectedRowChange={this.handleSelectedRowChange}
          clearFilters={"templatesDetail"}
          showFilterChips={true}
          toolbarChildren={
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: "21px", marginBottom: "-53px" }}>
              {this.state.maintenancemode ? (
                <>
                  <Button type="submit" variant="contained" color="primary" style={{ margin: "2px" }} onClick={this.handleSaveDirtyDetails}>
                    save changes
                  </Button>
                  <Button type="submit" variant="contained" color="primary" style={{ backgroundColor: "green", margin: "2px" }} onClick={this.handleAddNewTemplateLine}>
                    new template line
                  </Button>
                </>
              ) : (
                <Button type="submit" variant="contained" color="primary" style={{ margin: "2px" }} onClick={this.handleSelectTemplateDetailLines}>
                  add selected
                </Button>
              )}
            </div>
          }
        />
      </div >
    );
  }
}

export default withStyles(styles)(TemplatesDetailUnstyled);